import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from './Select';
import { getCircuits, clearCircuits } from '../../../../actions';
import {
  inputPropTypes,
  metaPropTypes,
  inputDefaultProps,
  metaDefaultProps,
} from '../../forms/input/InputPropTypes';
import { isValidNumber } from '../../../../utils/validators';

class CircuitSelect extends Component {
  componentWillUnmount() {
    const { dispatchClearCircuits } = this.props;
    dispatchClearCircuits();
  }

  handleCircuitChange = (inputValue) => {
    const { dispatchGetCircuits } = this.props;

    const value = inputValue.trim();

    if (value.length) {
      let query = [];

      if (isValidNumber(value)) {
        query = [`id:${value}`];
      } else if (value.length >= 4) {
        query = [`name:${value}`];
      }
      query.push('active:true')

      dispatchGetCircuits({ query });
    }
  };

  render() {
    const { options, loading, isMulti, input, meta, ...rest } = this.props;
    return (
      <Select
        options={options}
        isLoading={loading}
        isMulti={isMulti}
        // Select expects onChange and value inside input
        input={input}
        // Select expects touched, error, warning inside meta
        meta={meta}
        onInputChange={this.handleCircuitChange}
        {...rest}
      />
    );
  }
}

CircuitSelect.propTypes = {
  dispatchGetCircuits: PropTypes.func.isRequired,
  dispatchClearCircuits: PropTypes.func.isRequired,
  isMulti: PropTypes.bool,
  input: inputPropTypes,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string,
      routes: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.number,
          label: PropTypes.string,
        }),
      ),
    }),
  ),
  meta: metaPropTypes,
  loading: PropTypes.bool,
  placeholder: PropTypes.string,
};

CircuitSelect.defaultProps = {
  input: inputDefaultProps,
  meta: metaDefaultProps,
  loading: false,
  isMulti: false,
  options: [],
  placeholder: 'Busque por ID o nombre de Circuito',
};

const mapStateToProps = ({ RouteUnit }) => ({
  options: RouteUnit.Circuit.getIn(['all', 'content', 'content']).map(
    (circuit) => ({
      value: circuit.id,
      label: `${circuit.id} - ${circuit.name}`,
      routes: (circuit.circuitRouteList || [])
        .sort((a, b) => a.routeOrder - b.routeOrder)
        .map((circuitRoute) => ({
          value: circuitRoute.routeId,
          label: circuitRoute.route
            ? `${circuitRoute.route.id} - ${circuitRoute.route.name}`
            : `${circuitRoute.routeId}`,
          route: circuitRoute.route,
        })),
    }),
  ),
  loading: RouteUnit.Circuit.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetCircuits: getCircuits,
  dispatchClearCircuits: clearCircuits,
};

export default connect(mapStateToProps, mapDispatchToProps)(CircuitSelect);
